import { createRoot } from 'solid-js';
import { getOverlayMount } from '../../../../lib/overlay-mount';
export {
  getModalContentWidth,
  getViewportWidth,
  MODAL_CONTENT_WIDTH_DESIGN,
} from '../../../../lib/modal-layout';
import { Modal } from './Component';
import './style.css';

interface Props {
  content: any;
  title?: any;
  /** 标准 Alert 取消按钮文案（与 confirmText 同时传入时为双按钮） */
  cancelText?: any;
  /** 标准 Alert 确认按钮文案 */
  confirmText?: any;
  /** 点击取消按钮回调（之后会自动关闭弹窗） */
  onCancel?: () => void;
  /** 点击确认按钮回调（之后会自动关闭弹窗） */
  onConfirm?: () => void;
  disableClickMask?: boolean;
  /** 全宽弹层（如全屏详情），跳过 getModalContentWidth 计算 */
  fullWidth?: boolean;
}

export interface API {
  handleClose: () => void;
}

export const showModal = (props: Props) => {
  const { content, title, cancelText, confirmText, onCancel, onConfirm, disableClickMask, fullWidth } = props;
  let api = {} as API;
  createRoot((dispose) => {
    const mount = getOverlayMount();

    const close = () => {
      if (modal.parentNode === mount) {
        mount.removeChild(modal);
      }
      dispose();
    };

    let modal = Modal({
      content,
      title,
      cancelText,
      confirmText,
      onCancel,
      onConfirm,
      disableClickMask,
      fullWidth,
      close,
      api,
    }) as any;

    mount.appendChild(modal);
  });

  return {
    close: () => api.handleClose(),
  };
};
